import { useState, useEffect } from "react";
import EditableText from "./EditableText";

const Emblem = ({ rsvp, isEditable, onUpdate }) => {
  const [leftLetter, setLeftLetter] = useState(rsvp.emblemLeftLetter || "K");
  const [rightLetter, setRightLetter] = useState(rsvp.emblemRightLetter || "I");

  useEffect(() => {
    if (rsvp.emblemLeftLetter) {
      setLeftLetter(rsvp.emblemLeftLetter);
    }
    if (rsvp.emblemRightLetter) {
      setRightLetter(rsvp.emblemRightLetter);
    }
  }, [rsvp.emblemLeftLetter, rsvp.emblemRightLetter]);

  const handleLeftLetterChange = (text) => {
    const letter = text.charAt(0);
    setLeftLetter(letter);
    onUpdate?.({ emblemLeftLetter: letter });
  };

  const handleRightLetterChange = (text) => {
    const letter = text.charAt(0);
    setRightLetter(letter);
    onUpdate?.({ emblemRightLetter: letter });
  };

  const letterColor = rsvp.emblemColor || rsvp.titleColor || "#000000";

  return (
    <div className="flex flex-col items-end mr-6 justify-center mb-8">
      <div className="relative flex items-center">
        <div className="relative -top-6 mr-2">
          <EditableText
            text={leftLetter}
            onTextChange={handleLeftLetterChange}
            style={{
              color: letterColor,
            }}
            className={`font-bold font-${rsvp.emblemFont} text-center`}
            font={rsvp.emblemFont}
            color={letterColor}
            fontSize={rsvp.emblemFontSize || 48}
            isEditable={isEditable}
            isBold={rsvp.emblemIsBold}
            isItalic={rsvp.emblemIsItalic}
            onStyleChange={(style) => {
              if (style.font) onUpdate({ emblemFont: style.font });
              if (style.color) onUpdate({ emblemColor: style.color });
              if (style.fontSize) onUpdate({ emblemFontSize: style.fontSize });
              if (style.isBold !== undefined)
                onUpdate({ emblemIsBold: style.isBold });
              if (style.isItalic !== undefined)
                onUpdate({ emblemIsItalic: style.isItalic });
            }}
          />
        </div>

        <div
          className="h-36 w-0.5 mx-4"
          style={{ backgroundColor: letterColor }}
        ></div>

        <div className="relative top-6 ml-2">
          <EditableText
            text={rightLetter}
            onTextChange={handleRightLetterChange}
            style={{
              color: letterColor,
            }}
            className={`font-bold font-${rsvp.emblemFont} text-center`}
            font={rsvp.emblemFont}
            color={letterColor}
            fontSize={rsvp.emblemFontSize || 48}
            isBold={rsvp.emblemIsBold}
            isItalic={rsvp.emblemIsItalic}
            onStyleChange={(style) => {
              if (style.font) onUpdate({ emblemFont: style.font });
              if (style.color) onUpdate({ emblemColor: style.color });
              if (style.fontSize) onUpdate({ emblemFontSize: style.fontSize });
              if (style.isBold !== undefined)
                onUpdate({ emblemIsBold: style.isBold });
              if (style.isItalic !== undefined)
                onUpdate({ emblemIsItalic: style.isItalic });
            }}
            isEditable={isEditable}
          />
        </div>
      </div>
    </div>
  );
};

export default Emblem;
